<script setup lang="ts">
import { MetalPlanData } from '@/page/domain/MetalPlanData';
import PlanCoverage from '@/page/infrastructure/components/plans/PlanCoverage.vue';
import PlanName from '@/page/infrastructure/components/plans/PlanName.vue';

defineProps<{
  plan: MetalPlanData,
  clientCoverage?: boolean,
}>();
</script>
<template>
  <div class="flex flex-col sm:flex-row sm:flex-wrap border-blue-100 items-center py-4 justify-center lg:justify-between">
    <div class="sm:flex-[100%] lg:flex-1 flex justify-center lg:justify-start">
      <PlanName :plan-name="plan.tierName" :icon-img="plan.icon" class="py-4 lg:py-0"/>
    </div>
    <div class="sm:flex-[50%] lg:flex-1 flex justify-center md:justify-start">
      <div v-if="$slots['plan-coverage']" class="w-60 md:pl-8">
        <slot name="plan-coverage"></slot>
      </div>
      <PlanCoverage v-else :coverage="plan.coverage" title="This Plan Pays" subtitle="Of Your Health Costs."/>
    </div>
    <div class="sm:flex-[50%] lg:flex-1 flex">
      <div v-if="$slots['client-coverage']" class="w-60">
        <slot name="client-coverage"></slot>
      </div>
      <PlanCoverage v-else :coverage="100 - plan.coverage" title="You pay the remaining" :percentage-bar="true" class="py-4 lg:py-0"/>
    </div>
  </div>
</template>
